"use client"
import { useDispatch, useSelector } from 'react-redux'
import { Box } from '@quintoandar-tokko/jopijs'
import Skeletons from "@/components/fichaInfo/skelenton/Skeleton";
import { setCalendarData } from '@/store/slices/components/calendar/CalendarSlice'
import { formatDate } from '../utils/dates'
import style from './timeSelector.module.scss'

const SKELETONS = [1, 2, 3, 4, 5]

export default function TimeSelector () {
  const calendar = useSelector(state => state.CalendarSlice)
  const dispatch = useDispatch()

  const handleClick = (time) => {
    dispatch(setCalendarData({ key: 'visit', subkey: 'hour', value: time }))
  }

  return (  
    <Box className={style.timeSelectorContainer}>
      <Box as="span" className={style.selectedDateText}>
        {formatDate(calendar.visit.date)}
      </Box>
      <Box className={style.timeSelectorItemsContainer}>
        <Box as="ul" className={style.timeSelectorItemsContainerWrapperWithOverflow}>
          {calendar.schedule.loadingHours && SKELETONS.map(skeleton => (
              <Skeletons key={skeleton} width="100%" height={42} borderRadius={8}  />
          ))}

          {!calendar.schedule.loadingHours && calendar.schedule.availableHours.map(hour => (
            <Box as="li" key={hour}>
              <Box
                as="button"
                className={style.timeSelectorButton}
                onClick={() => handleClick(hour)}
                data-active={hour === calendar.visit.hour}
              >
                {hour}
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  )
}
